import * as React from 'react'

import { useVariant } from '../../../../client/hooks/use-variant'
import { XP_LOYALTY_BANNER } from '../../../../client/components/ExperimentsProvider/experiment-definitions'

import { PromoBannerCarousel } from '../PromoBannerCarousel'
import { useGetPromoBanners } from '../useGetPromoBanners'

export interface PromoBannerProps {
  testId?: string
}

export const PromoBanner = ({ testId = 'promo-banner' }: PromoBannerProps) => {
  const { data: { promoBanners } = {}, error, loading } = useGetPromoBanners()
  const displayLoyaltyBannerVariant = !!useVariant(
    XP_LOYALTY_BANNER.experimentName
  )

  if (loading || error || !promoBanners) {
    return null
  }

  const banners = [
    ...promoBanners.promoCodeBanners,
    ...(displayLoyaltyBannerVariant ? promoBanners.loyaltyBanners : [])
  ]

  if (banners.length === 0) {
    return null
  }

  return <PromoBannerCarousel banners={banners} testId={testId} />
}
